module.exports = __webpack_public_path__ + "static/assets/9909ed317771ffe00c17070ea8b337d3.svg";